import { useNavigate } from 'react-router-dom'
import type { NavItem } from '@vnetwork/datacentral-ui/shells'
import { cn } from '@/lib/utils'

interface MobileTabBarProps {
    nav: NavItem[]
    activeId?: string
    /** Number of shortcuts shown. @default 4 */
    limit?: number
}

/**
 * Mobile bottom bar: the first visible top-level destinations. The full menu
 * stays one tap away in the shell's drawer (topbar menu button).
 */
const MobileTabBar = ({ nav, activeId, limit = 4 }: MobileTabBarProps) => {
    const navigate = useNavigate()
    const items = nav
        .filter((i) => !i.hidden && i.href && !i.external && !i.items)
        .slice(0, limit)
    return (
        <>
            {items.map((item) => (
                <a
                    key={item.id}
                    href={item.href}
                    onClick={(e) => {
                        e.preventDefault()
                        navigate(item.href!)
                    }}
                    className={cn(
                        'flex flex-1 flex-col items-center justify-center gap-1 text-xs text-muted-foreground no-underline',
                        item.id === activeId && 'text-primary font-medium'
                    )}
                >
                    <span className="inline-flex [&_svg]:w-5 [&_svg]:h-5">
                        {item.icon}
                    </span>
                    <span className="max-w-full truncate px-1">
                        {item.label}
                    </span>
                </a>
            ))}
        </>
    )
}

export default MobileTabBar
